import {html, LitElement} from 'lit';
import {store} from '@/store.js';

class AcaSigninAutoRedirect extends LitElement {
    static get is() {
        return 'aca-signin-auto-redirect';
    }

    render() {
        return html``;
    }

    connectedCallback() {
        super.connectedCallback();

        store.dispatch({type: 'SIGNIN'});
    }
}

window.customElements.define(AcaSigninAutoRedirect.is, AcaSigninAutoRedirect);
